 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0defc746":"5acad877","chunk-1155d2ff":"a5ef36f0","chunk-1a0266b9":"0a4c3fa6","chunk-20e0d197":"f1bd383e","chunk-216dd30c":"1a24ec55","chunk-294c3a48":"f9761ecf","chunk-2f44a912":"0e8eb599","chunk-40171351":"2e08190c","chunk-527e6236":"9b65a000","chunk-52cc7ee1":"58030ddc","chunk-61fa3cc5":"6b69fa22","chunk-81caa08c":"6582804a","chunk-a9139c54":"a230172d","chunk-e36fc55a":"2cd67f00","chunk-e64f91e0":"2949b110","chunk-e7d502b0":"9264833e","chunk-43b11cda":"f84e20c8","chunk-fd790b06":"e1165caa","chunk-1f0267b8":"0c85bdc6","chunk-1f417238":"3e6dbd91","chunk-3a980d07":"1f06a98a","chunk-2d0cc414":"48277657","chunk-2d0cec1c":"6c86f8fd","chunk-2d216f62":"3944d362","chunk-63fcb59b":"cf933d33","chunk-cdeb9a80":"8f776ee0","chunk-d7c1500e":"84a9c19d","chunk-00f86c8a":"2a98f29c","chunk-2d20f165":"73149bc5","chunk-5c9ae8d6":"63c58b99","chunk-f608e078":"8b6c015f","chunk-1aaa8b62":"b80758c3","chunk-72df87cc":"a1473015","chunk-499b1a97":"09c11f7c","chunk-27e58756":"dfb22b53","chunk-2cd3a828":"298dca8e","chunk-3eae384f":"b8a0a044","chunk-55f913dd":"cc702efe","chunk-5a0087fe":"7eff13a3","chunk-7a920559":"606cf9c7","chunk-fd11e7a0":"8adfc8d4","chunk-2d0bff7f":"84f24821","chunk-8e8de3ca":"d7d5055a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0defc746":1,"chunk-1155d2ff":1,"chunk-1a0266b9":1,"chunk-20e0d197":1,"chunk-216dd30c":1,"chunk-294c3a48":1,"chunk-2f44a912":1,"chunk-40171351":1,"chunk-527e6236":1,"chunk-52cc7ee1":1,"chunk-61fa3cc5":1,"chunk-81caa08c":1,"chunk-a9139c54":1,"chunk-e64f91e0":1,"chunk-e7d502b0":1,"chunk-43b11cda":1,"chunk-fd790b06":1,"chunk-1f0267b8":1,"chunk-1f417238":1,"chunk-63fcb59b":1,"chunk-cdeb9a80":1,"chunk-d7c1500e":1,"chunk-00f86c8a":1,"chunk-f608e078":1,"chunk-1aaa8b62":1,"chunk-499b1a97":1,"chunk-27e58756":1,"chunk-2cd3a828":1,"chunk-3eae384f":1,"chunk-55f913dd":1,"chunk-7a920559":1,"chunk-fd11e7a0":1,"chunk-8e8de3ca":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0defc746":"f27465a0","chunk-1155d2ff":"2542b99f","chunk-1a0266b9":"2deef07b","chunk-20e0d197":"0211ac63","chunk-216dd30c":"9e4498c3","chunk-294c3a48":"1c90070a","chunk-2f44a912":"5a61b165","chunk-40171351":"e591f67b","chunk-527e6236":"dcbd2c68","chunk-52cc7ee1":"3a44478a","chunk-61fa3cc5":"01a1fdfb","chunk-81caa08c":"42ca37d3","chunk-a9139c54":"dccd6955","chunk-e36fc55a":"31d6cfe0","chunk-e64f91e0":"0f9a34f7","chunk-e7d502b0":"8268f536","chunk-43b11cda":"c7e6bc53","chunk-fd790b06":"b86afa95","chunk-1f0267b8":"e72f3538","chunk-1f417238":"a2a49263","chunk-3a980d07":"31d6cfe0","chunk-2d0cc414":"31d6cfe0","chunk-2d0cec1c":"31d6cfe0","chunk-2d216f62":"31d6cfe0","chunk-63fcb59b":"63d7d339","chunk-cdeb9a80":"2deef07b","chunk-d7c1500e":"945e7f77","chunk-00f86c8a":"68b24371","chunk-2d20f165":"31d6cfe0","chunk-5c9ae8d6":"31d6cfe0","chunk-f608e078":"d821c3a5","chunk-1aaa8b62":"38a06421","chunk-72df87cc":"31d6cfe0","chunk-499b1a97":"63d7d339","chunk-27e58756":"63d7d339","chunk-2cd3a828":"63d7d339","chunk-3eae384f":"63d7d339","chunk-55f913dd":"63d7d339","chunk-5a0087fe":"31d6cfe0","chunk-7a920559":"63d7d339","chunk-fd11e7a0":"e51afad3","chunk-2d0bff7f":"31d6cfe0","chunk-8e8de3ca":"63d7d339"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/Scripts/source/vue/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
